import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3v18","key":"svg-0"}],["path",{"d":"M9 18l3 3l3 -3","key":"svg-1"}],["path",{"d":"M9 3h6","key":"svg-2"}]]

/**
 * IconArrowDownBar
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZG93bi1iYXIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDN2MTgiIC8+CiAgPHBhdGggZD0iTTkgMThsMyAzbDMgLTMiIC8+CiAgPHBhdGggZD0iTTkgM2g2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-down-bar
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowDownBar = createReactComponent('outline', 'arrow-down-bar', 'ArrowDownBar', __iconNode);

export default IconArrowDownBar;